import React from 'react';
import styles from './style.module.css';
import StepNineForm from '../../components/forms/step-nine';
import InfoBox from '../../../../common/components/info-box';

const tooltip = {
    title: 'What are your goals?',
    content: <span>Have you thought about what you want to accomplish in 3 years time? Do you have a clear vision of how to get there? Reflecting on these questions can help you set clear, actionable goals.</span>
};

export default () => (
    <div className={styles.page}>
        <p className={styles.topTitle}>My Prosperity Strategy</p>
        <h1 className={styles.mainTitle}>My Goals</h1>
        <p className={styles.text}>What will you do this year on your prosperity journey?</p>
        <StepNineForm/>
        <InfoBox
            title={tooltip.title}
            content={tooltip.content}
        />
    </div>
);
